export default function initMultiselect() {
  document.querySelectorAll('.custom-multiselect').forEach(parent => {
    const field = parent.querySelector(".custom-multiselect-field");
    const checkboxes = parent.querySelectorAll('input[type="checkbox"]');
    const dropdown = parent.querySelector('.custom-multiselect-drop');

    field.addEventListener('click', (e) => {
      dropdown.classList.toggle('opened');
      e.stopPropagation();
    });

    document.addEventListener('click', (e) => {
      if (!parent.contains(e.target)) {
        dropdown.classList.remove('opened');
      }
    });

    const createButton = (checkbox) => {
      const label = checkbox.nextElementSibling.textContent;
      const button = document.createElement('button');
      button.className = "btn-multiselect";
      button.textContent = label;
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        checkbox.checked = !checkbox.checked;
        button.remove();
      });

      return button;
    };

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        field.innerHTML = '';

        checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            const button = createButton(checkbox);
            field.appendChild(button);
          }
        });
      });

      if (checkbox.checked) {
        const button = createButton(checkbox);
        field.appendChild(button);
      }
    });
  });
}